import Vue from 'vue';
import { bus } from '@/util/bus';
import api from '@/api/signup';

import router from './router';
import store from './store';
import i18n from './i18n';
import './directives';
import { AppLoading } from './util/metrics';
import App from './App.vue';
import busy from '@/plugins/busy';

AppLoading();

import { isIframe } from './util/browser';
import { search } from './util/location';
import { logger } from './util/logger';
import { rehydrateStore } from './util/store';
import { clientResolution } from './util/client';

try {
  const prevState = search.state;
  if (prevState) {
    rehydrateStore(encodeURIComponent(prevState), store);
  }
  const button = () =>
    import(/* webpackChunkName: "systembuttons" */ '@/components/Ui/AsButton.vue');
  Vue.component('AsButton', button);
  const Vuelidate = require('vuelidate').default; // vuelidate doesnt have types
  Vue.use(Vuelidate);
  Vue.use(busy);
  Vue.config.productionTip = false;
  api.interceptors.response.use(undefined, (err) => {
    switch (err.message) {
      case 'Network Error':
        bus.$emit('something');
        break;
    }
  });
  const clientScript = document.createElement('script');
  clientScript.src = `/js/client/${clientResolution.clientCode}.js`;
  clientScript.async = true;
  clientScript.onerror = () => {
    logger.log('failed to load')
  };
  document.getElementsByTagName('head')[0].appendChild(clientScript);
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
} catch (ex) {
  throw ex;
}
